import React from "react";
import AdultsCount from "./adultsCount";
import Input from './textfield/input'
import VacationType from "./vacationType";
import Budget from "./budget";
import Calender from "./calander";
import DurationofTrip from "./duration";
import PhoneInputs from './phone'

const ComponentMap = (props: any) => {
    const { node, data, change, setSelectionRange, selectionRange, dayFlex, setDayFlex, toggleHover, setToggleHover } = props;

    return (
        <div>

            {node.type === 'adults' ? <AdultsCount node={node} data={data} change={change} />
                : node.type === 'calender' ? <Calender toggleHover={toggleHover} setToggleHover={setToggleHover} node={node} dayFlex={dayFlex} setDayFlex={setDayFlex} data={data} change={change} setSelectionRange={setSelectionRange} selectionRange={selectionRange} />
                    : node.type === 'VT' ? <VacationType node={node} data={data} change={change} />
                        : node.type === 'budget' ? <Budget node={node} data={data} change={change} />
                            : node.type === 'add' ? <DurationofTrip node={node} data={data} change={change} />
                                : node.type === 'phone' ? <PhoneInputs node={node} data={data} change={change} />
                                    : <Input node={node} data={data} change={change} />}

        </div>
    )
}
export default ComponentMap;